const s = {
  name: "Relieved",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M35,0l0.8,1.3l0,0.1c0,0,0.1,0.1,0.1,0.2c0.1,0.2,0.3,0.4,0.5,0.7c0.4,0.6,0.9,1.4,1.4,2.3
			c0.5,0.9,1,1.9,1.4,2.8C39.7,8.3,40,9.2,40,10c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5c0-0.8,0.3-1.7,0.7-2.6c0.4-0.9,0.9-1.9,1.4-2.8
			c0.5-0.9,1-1.7,1.4-2.3c0.2-0.3,0.3-0.5,0.5-0.7c0.1-0.1,0.1-0.2,0.1-0.2l0-0.1l0,0L35,0z M35,3.7c-0.3,0.5-0.7,1.2-1.1,1.9
			c-0.5,0.9-1,1.8-1.3,2.6C32.2,9.1,32,9.7,32,10c0,1.7,1.3,3,3,3s3-1.3,3-3c0-0.3-0.2-1-0.5-1.8c-0.4-0.8-0.8-1.7-1.3-2.6
			C35.7,4.9,35.3,4.2,35,3.7z"/>
		<path class="st0" d="M20,2C10.1,2,2,10.1,2,20c0,9.9,8.1,18,18,18s18-8.1,18-18h2c0,11-9,20-20,20C9,40,0,31,0,20C0,9,9,0,20,0V2z
			"/>
		<path class="st0" d="M11.5,24.5c2.2,2.2,5.2,3.5,8.5,3.5s6.3-1.3,8.5-3.5l-1.4-1.4C25.3,24.9,22.8,26,20,26s-5.3-1.1-7.1-2.9
			L11.5,24.5z"/>
		<path class="st0" d="M28,17c-1.1,0-2,0.9-2,2h-2c0-2.2,1.8-4,4-4s4,1.8,4,4h-2C30,17.9,29.1,17,28,17z"/>
		<path class="st0" d="M10,19c0-1.1,0.9-2,2-2s2,0.9,2,2h2c0-2.2-1.8-4-4-4s-4,1.8-4,4H10z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Relieved
};
